document.addEventListener('DOMContentLoaded', function() {
  // Only initialize the carousel if it's visible in viewport or user scrolls near it
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        initializeCarousel();
        observer.disconnect(); // Only need to initialize once
      }
    });
  }, {
    rootMargin: '200px 0px', // Initialize 200px before it comes into view
    threshold: 0.01
  });
  
  // Start observing the carousel section
  const carouselSection = document.querySelector('.review-carousel-section');
  if (carouselSection) {
    observer.observe(carouselSection);
  } else {
    // Fallback if section not found
    initializeCarousel();
  }
  
  // Start preloading immediately - even before section is visible
  // This runs regardless of whether the section is visible
  preloadModalResources();
});

// Eagerly preload resources needed for modal before user interaction
function preloadModalResources() {
  // Preload all possible images with low priority
  const modalData = document.querySelectorAll('.review-modal-data');
  
  if (!modalData.length) return;
  
  // Use requestIdleCallback to do this work when browser is idle
  (window.requestIdleCallback || setTimeout)(() => {
    const imagesToPreload = new Set();
    
    // Collect all image URLs that might be needed
    modalData.forEach(data => {
      const imageElements = data.querySelectorAll('[data-image-url]');
      imageElements.forEach(el => {
        const url = el.getAttribute('data-image-url');
        if (url) imagesToPreload.add(url);
      });
      
      // Add product image if available
      const productImageEl = data.querySelector('[data-product-image]');
      if (productImageEl) {
        const url = productImageEl.getAttribute('data-product-image');
        if (url) imagesToPreload.add(url);
      }
    });
    
    // Preload all discovered images with low priority
    imagesToPreload.forEach(url => {
      const img = new Image();
      img.src = url;
      img.fetchPriority = 'low';
      img.loading = 'lazy'; // Use lazy loading for preloads
      img.setAttribute('importance', 'low');
    });
    
    // Also create and cache all modal elements but keep them hidden
    // This happens in the background while user browses
    createPreloadedModals();
  }, { timeout: 2000 }); // 2 second max timeout
}

// Global storage for preloaded modal elements
const preloadedModals = new Map();

// Create all modals once and store them for instant display later
function createPreloadedModals() {
  const cards = document.querySelectorAll('.shopify-review-card');
  
  cards.forEach((card, index) => {
    const modalData = card.querySelector('.review-modal-data');
    if (modalData) {
      // Extract data now but don't display yet
      const reviewData = extractReviewData(modalData);
      if (!reviewData) return;
      
      // Create the modal in memory but don't attach to DOM yet
      const modal = document.createElement('div');
      modal.className = 'review-modal-overlay';
      modal.style.display = 'none';
      modal.style.willChange = 'opacity, transform';
      
      // Create modal content with all the elements and event listeners
      modal.innerHTML = createModalHTML(reviewData);
      
      // Save the preloaded modal
      preloadedModals.set(index, {
        modal,
        reviewData
      });
      
      // Attach event handlers
      setupModalEventHandlers(modal, reviewData);
    }
  });
  
  // After 1 second, actually attach modals to DOM but keep them hidden
  // This ensures they're ready to display instantly
  setTimeout(() => {
    // Append all modals to DOM at once for better performance
    const fragment = document.createDocumentFragment();
    preloadedModals.forEach(({modal}) => {
      fragment.appendChild(modal);
    });
    document.body.appendChild(fragment);
  }, 100); // Faster initial preload
}

function setupModalEventHandlers(modal, reviewData) {
  // Close button
  const closeButton = modal.querySelector('.review-modal-close');
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      hideModal(modal);
    });
  }
  
  // Image navigation
  if (reviewData.images && reviewData.images.length > 1) {
    const prevButton = modal.querySelector('.review-modal-navigation.prev');
    const nextButton = modal.querySelector('.review-modal-navigation.next');
    const thumbnails = modal.querySelectorAll('.review-modal-thumbnail');
    
    let currentIndex = 0;
    
    // Set up image navigation
    if (prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        currentIndex = (currentIndex - 1 + reviewData.images.length) % reviewData.images.length;
        updateModalImage(modal, reviewData.images[currentIndex], currentIndex);
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        currentIndex = (currentIndex + 1) % reviewData.images.length;
        updateModalImage(modal, reviewData.images[currentIndex], currentIndex);
      });
    }
    
    // Thumbnail clicks
    thumbnails.forEach((thumbnail, idx) => {
      thumbnail.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        currentIndex = idx;
        updateModalImage(modal, reviewData.images[idx], idx);
      });
    });
  }
  
  // Click outside to close
  modal.addEventListener('click', (e) => {
    const content = modal.querySelector('.review-modal-content');
    if (content && !content.contains(e.target)) {
      hideModal(modal);
    }
  });
  
  // Prevent clicks inside modal from bubbling up to close
  const modalContent = modal.querySelector('.review-modal-content');
  if (modalContent) {
    modalContent.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }
}

function updateModalImage(modal, imageSrc, index) {
  const image = modal.querySelector('.review-modal-image');
  const blurBg = modal.querySelector('.review-modal-image-blur');
  const thumbnails = modal.querySelectorAll('.review-modal-thumbnail');
  
  if (image) image.src = imageSrc;
  if (blurBg) blurBg.style.backgroundImage = `url(${imageSrc})`;
  
  thumbnails.forEach((thumb, idx) => {
    thumb.classList.toggle('active', idx === index);
  });
}

function initializeCarousel() {
  const carouselTrack = document.querySelector('.shopify-carousel-track');
  const cards = document.querySelectorAll('.shopify-review-card');
  const prevButton = document.querySelector('.shopify-nav-button.prev');
  const nextButton = document.querySelector('.shopify-nav-button.next');
  
  if (!carouselTrack || !prevButton || !nextButton || cards.length === 0) {
    console.error('Carousel elements not found or no cards available');
    return;
  }
  
  // Apply default cursor to all card elements
  cards.forEach(card => {
    card.style.cursor = 'default';
    
    // Make all elements inside the card non-clickable by default
    Array.from(card.querySelectorAll('*')).forEach(el => {
      if (!(el.classList.contains('review-image') || 
            el.classList.contains('read-more-button') || 
            el.classList.contains('see-product-button'))) {
        el.style.pointerEvents = 'none';
      }
    });
  });
  
  // Set up card click events - only make interactive elements clickable
  cards.forEach((card, index) => {
    setupCardClickHandlers(card, index);
  });
  
  // Initialize carousel navigation
  initCarouselNavigation(carouselTrack, cards, prevButton, nextButton);
  
  // Set up global modal close events
  setupModalCloseEvents();
  
  // Add CSS to prevent clickable cursor on non-interactive elements
  const style = document.createElement('style');
  style.textContent = `
    .shopify-review-card {
      cursor: default !important;
    }
    .shopify-review-card * {
      cursor: default !important;
    }
    .review-image,
    .read-more-button,
    .see-product-button {
      cursor: pointer !important;
      pointer-events: auto !important;
    }
    .shopify-nav-button {
      cursor: pointer !important;
      pointer-events: auto !important;
    }
  `;
  document.head.appendChild(style);
}

// Make only specific elements in the card clickable
function setupCardClickHandlers(card, index) {
  // Reset all elements to non-clickable
  card.style.cursor = 'default';
  
  // Find only the elements that should be clickable
  const readMoreButton = card.querySelector('.read-more-button');
  const reviewImage = card.querySelector('.review-image');
  const productLink = card.querySelector('.see-product-button');
  
  // Make "Read more" button clickable
  if (readMoreButton) {
    readMoreButton.style.cursor = 'pointer';
    readMoreButton.style.pointerEvents = 'auto';
    readMoreButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showPreloadedModal(index);
    });
  }
  
  // Make review image clickable
  if (reviewImage) {
    reviewImage.style.cursor = 'pointer';
    reviewImage.style.pointerEvents = 'auto';
    
    // This is the critical fix - make sure click events on the image open the modal
    reviewImage.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showPreloadedModal(index);
    });
    
    // Also make the image itself clickable, not just the container
    const imageElement = reviewImage.querySelector('img');
    if (imageElement) {
      imageElement.style.cursor = 'pointer';
      imageElement.style.pointerEvents = 'auto';
      imageElement.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        showPreloadedModal(index);
      });
    }
  }
  
  // Make sure product link is clickable but doesn't trigger modal
  if (productLink) {
    productLink.style.cursor = 'pointer';
    productLink.style.pointerEvents = 'auto';
    productLink.addEventListener('click', function(e) {
      // Allow default behavior to navigate to the product
      e.stopPropagation(); // Prevent modal from opening
    });
  }
  
  // Prevent click events on the card itself from propagating
  card.addEventListener('click', function(e) {
    // Only if the click is directly on the card (not on the clickable elements)
    if (e.target === card) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
}

// Create the complete HTML for a modal
function createModalHTML(review) {
  return `
    <div class="review-modal-content" style="will-change: transform, opacity; backface-visibility: hidden; -webkit-backface-visibility: hidden;">
      <button class="review-modal-close" aria-label="Close modal">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
      
      <div class="review-modal-image-section">
        ${createImageSectionHTML(review)}
      </div>
      
      <div class="review-modal-content-section">
        ${createContentSectionHTML(review)}
      </div>
    </div>
  `;
}

// Extract review data from modalData element
function extractReviewData(modalData) {
  if (!modalData) return null;
  
  // Get verified badge and text colors from the section data attributes
  const carouselSection = document.querySelector('.review-carousel-section');
  const verifiedBadgeColor = carouselSection ? carouselSection.getAttribute('data-modal-verified-badge-color') : '#22c55e';
  const verifiedTextColor = carouselSection ? carouselSection.getAttribute('data-modal-verified-text-color') : '#22c55e';
  
  // Extract review data
  const reviewData = {
    name: modalData.getAttribute('data-reviewer') || 'Customer',
    date: modalData.getAttribute('data-date') || '',
    verified: modalData.getAttribute('data-verified') === 'true',
    text: modalData.getAttribute('data-full-text') || '',
    productTitle: modalData.getAttribute('data-product-title') || 'Product',
    productUrl: modalData.getAttribute('data-product-url') || '#',
    rating: parseInt(modalData.getAttribute('data-rating') || '5'),
    images: [],
    verifiedBadgeColor,
    verifiedTextColor
  };
  
  // Get all images
  const imageElements = modalData.querySelectorAll('[data-image-url]');
  reviewData.images = Array.from(imageElements)
    .map(el => el.getAttribute('data-image-url'))
    .filter(Boolean);
  
  // If no images found, use the card image
  if (reviewData.images.length === 0) {
    const cardImage = modalData.closest('.shopify-review-card').querySelector('.review-image img');
    if (cardImage && cardImage.src) {
      reviewData.images.push(cardImage.src);
    }
  }
  
  // Get product image
  const productImageEl = modalData.querySelector('[data-product-image]');
  reviewData.productImage = productImageEl 
    ? productImageEl.getAttribute('data-product-image') 
    : (reviewData.images[0] || '');
    
  return reviewData;
}

// Show a preloaded modal immediately
function showPreloadedModal(cardIndex) {
  const preloadedModal = preloadedModals.get(cardIndex);
  if (!preloadedModal) return;
  
  const { modal } = preloadedModal;
  
  // Instantly display
  document.body.style.overflow = 'hidden';
  modal.style.display = 'flex';
  
  // Force reflow
  void modal.offsetWidth;
  
  // Add visible class instantly
  requestAnimationFrame(() => {
    modal.classList.add('visible');
    const content = modal.querySelector('.review-modal-content');
    if (content) content.classList.add('visible');
  });
}

// Hide modal with fast animation
function hideModal(modal) {
  if (!modal) return;
  
  const modalContent = modal.querySelector('.review-modal-content');
  if (modalContent) {
    modalContent.classList.remove('visible');
  }
  
  modal.classList.remove('visible');
  
  // CRUCIAL FIX: Restore pointer events immediately to fix clickability issue
  document.body.style.overflow = '';
  
  // Hide modal after a very brief delay - reduced to almost nothing
  setTimeout(() => {
    modal.style.display = 'none';
  }, 50); // Drastically reduced - the key fix for the unresponsive UI after closing
}

// Global modal close handler
function setupModalCloseEvents() {
  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const visibleModal = document.querySelector('.review-modal-overlay.visible');
      if (visibleModal) {
        hideModal(visibleModal);
      }
    }
  });
}

// Create image section HTML
function createImageSectionHTML(review) {
  if (!review.images.length) return '';
  
  // Create the image container with hardware acceleration hints
  const imageContainerHTML = `
    <div class="review-modal-image-container" style="will-change: opacity, transform;">
      <div class="review-modal-image-blur" style="background-image: url(${review.images[0]}); will-change: opacity; transform: scale(1.05)"></div>
      <img src="${review.images[0]}" alt="Review by ${review.name}" class="review-modal-image" data-image-index="0" loading="eager" fetchpriority="high">
      ${review.images.length > 1 ? `
        <button class="review-modal-navigation prev" aria-label="Previous image">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
        </button>
        <button class="review-modal-navigation next" aria-label="Next image">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>
      ` : ''}
    </div>
  `;
  
  // Create thumbnails if multiple images
  const thumbnailsHTML = review.images.length > 1 ? `
    <div class="review-modal-thumbnails">
      ${review.images.map((src, index) => `
        <div class="review-modal-thumbnail ${index === 0 ? 'active' : ''}">
          <img src="${src}" alt="Thumbnail ${index + 1}" loading="lazy">
        </div>
      `).join('')}
    </div>
  ` : '';
  
  return imageContainerHTML + thumbnailsHTML;
}

// Create content section HTML
function createContentSectionHTML(review) {
  // Stars HTML
  const starsHTML = Array(5).fill('★').map((star, i) => 
    `<span class="review-modal-star ${i < review.rating ? 'filled' : ''}">★</span>`
  ).join('');
  
  // Verified badge if applicable
  const verifiedHTML = review.verified ? `
    <span class="review-modal-verified-badge" style="background-color: ${review.verifiedBadgeColor};">
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
    </span>
    <span class="review-modal-verified-text" style="color: ${review.verifiedTextColor};">Verified</span>
  ` : '';
  
  return `
    <div class="review-modal-reviewer">
      <div class="review-modal-reviewer-name">${review.name}</div>
      ${verifiedHTML}
    </div>
    
    <div class="review-modal-stars">
      ${starsHTML}
    </div>
    
    <div class="review-modal-date">${review.date}</div>
    <div class="review-modal-text">${review.text}</div>
    
    <div class="review-modal-divider"></div>
    
    <div class="review-modal-product">
      ${review.productImage ? `<img src="${review.productImage}" class="review-modal-product-image" alt="${review.productTitle}" loading="lazy">` : ''}
      <div class="review-modal-product-name">${review.productTitle}</div>
    </div>
    
    <a href="${review.productUrl}" class="review-modal-product-link">
      See Product
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
    </a>
  `;
}

// Optimized carousel navigation with smoother animation
function initCarouselNavigation(track, cards, prevButton, nextButton) {
  if (!track || cards.length === 0) return;
  
  // Calculate how many cards can fit based on screen width
  function calculateVisibleCards() {
  if (window.innerWidth >= 992) {
    return 5; // desktop
  } else if (window.innerWidth >= 768) {
    return 3; // tablet
  } else {
    return 1; // mobile
  }
}

  
  let visibleCards = calculateVisibleCards();
  let currentIndex = 0;
  const totalCards = cards.length;
  
  // Use transform: translate3d for hardware acceleration
  function updateTrackPosition() {
    const cardWidth = 100 / visibleCards;
    const movePercentage = currentIndex * cardWidth;
    track.style.transform = `translate3d(-${movePercentage}%, 0, 0)`;
    updateButtonStates();
  }
  
  function updateButtonStates() {
    prevButton.disabled = currentIndex <= 0;
    nextButton.disabled = currentIndex >= totalCards - visibleCards;
    
    prevButton.style.opacity = prevButton.disabled ? '0.3' : '1';
    nextButton.style.opacity = nextButton.disabled ? '0.3' : '1';
    prevButton.style.cursor = prevButton.disabled ? 'default' : 'pointer';
    nextButton.style.cursor = nextButton.disabled ? 'default' : 'pointer';
  }
  
  // Event listeners for navigation buttons - made more responsive
  prevButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (currentIndex > 0) {
      currentIndex--;
      updateTrackPosition();
    }
  }, { passive: false });
  
  nextButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (currentIndex < totalCards - visibleCards) {
      currentIndex++;
      updateTrackPosition();
    }
  }, { passive: false });
  
  // Debounce the resize event handler
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const newVisibleCards = calculateVisibleCards();
      if (newVisibleCards !== visibleCards) {
        visibleCards = newVisibleCards;
        // Adjust current index if needed
        if (currentIndex > totalCards - visibleCards) {
          currentIndex = Math.max(0, totalCards - visibleCards);
        }
        updateTrackPosition();
      }
    }, 100);
  });
  
  // Touch support for mobile with improved touch handling
  let touchStartX = 0;
  let touchEndX = 0;
  const minSwipeDistance = 50;
  
  track.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  
  track.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });
  
  function handleSwipe() {
    const distance = touchStartX - touchEndX;
    
    if (Math.abs(distance) > minSwipeDistance) {
      if (distance > 0 && currentIndex < totalCards - visibleCards) {
        // Swipe left, show next
        currentIndex++;
      } else if (distance < 0 && currentIndex > 0) {
        // Swipe right, show previous
        currentIndex--;
      }
      updateTrackPosition();
    }
  }
  
  // Initialize the track position
  updateTrackPosition();
  
  // Make sure navigation buttons are always clickable
  prevButton.style.pointerEvents = 'auto';
  nextButton.style.pointerEvents = 'auto';
}